const money = new Intl.NumberFormat("en-EG", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const count = new Intl.NumberFormat("en-EG", { maximumFractionDigits: 0 });

export const certaintyLabel = {
  Actual: "مسجّل",
  Estimated: "تقديري",
  Incomplete: "ناقص",
  NotApplicable: "غير محسوب",
};

export function formatMoney(amount, certainty) {
  if (certainty === "NotApplicable" || amount == null) return "غير محسوب";
  const text = `${money.format(amount)} ج.م`;
  if (certainty === "Estimated") return `${text} تقديري`;
  if (certainty === "Incomplete") return `${text} ناقص`;
  return text;
}

export function formatCount(value) {
  if (value == null) return "—";
  return count.format(value);
}

export function formatPercent(value) {
  if (value == null) return "غير محسوب";
  return `${money.format(value)}%`;
}

export function certaintyClass(certainty) {
  if (certainty === "Actual") return "bg-emerald-50 text-emerald-700";
  if (certainty === "Estimated") return "bg-amber-50 text-amber-800";
  if (certainty === "Incomplete") return "bg-rose-50 text-rose-700";
  return "bg-slate-100 text-slate-500";
}
